/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_AllInputs */



/**
* | output |
* | --- |
* | "All" |
*
* @param {Og_Cfg_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_all = /** @type {((inputs?: Og_Cfg_AllInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_AllInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti")
	return /** @type {LocalizedString} */ ("All")
});